import React from 'react';

const stats = [
  { number: '100', label: 'Taxi Units' },
  { number: '87', label: 'Years Experience', highlight: true },
  { number: '100', label: 'Happy Clients' },
  { number: '100', label: 'Membership' },
];

const Stats = () => {
  return (
    <section className="stats-section">
      <p className="stats-tag">EXPERIENCE</p>
      <h2 className="stats-heading">WE ARE EXPERIENCED SINCE</h2>
      <div className="stats-grid">
        {stats.map((stat, i) => (
          <div key={i} className={`stat-card${stat.highlight ? ' stat-highlight' : ''}`}>
            <span className="stat-number">{stat.number}</span>
            <span className="stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
